<template>
    <div class="initiate-wrap">
        <van-nav-bar title="查看合同信息" left-text="返回" left-arrow @click-left="onClickLeft" />
        <van-collapse v-model="activeNames" accordion>
            <van-collapse-item :name="info.id" v-for="info in contract" :key="info.id">
                <template #title>
                    <div>{{ info.contractName }}</div>
                </template>

                <div class="row"><strong>合同编号:</strong> {{ info.contractNumber }}</div>
                <div class="row"><strong>合同名称:</strong> {{ info.contractName }}</div>
                <div class="row"><strong>销售:</strong> {{ info.sales?.name }}</div>
                <div class="row"><strong>有效期限:</strong> {{ info.expirationDate + '年' }}</div>
                <div class="row"><strong>合同拟定时间:</strong> {{ info.contractDraftingDate }}</div>
                <div class="row"><strong>合同金额:</strong> {{ info.contractAmount }}</div>
                <div class="row"
                    v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(info.contractType)">
                    <strong>增值金额:</strong> {{ info.addedAmount + '(' +
                    getProportion(info.contractAmount,
                    info.addedAmount) + ')' }}
                </div>
                <div class="row"><strong>客户联系人:</strong>
                    <span v-if="info?.customerContacts?.contactName">{{
                        info.customerContacts.contactName }}</span>
                    <span v-else style="color: #dd6161">系统内未找到</span>
                </div>

                <div class="row"><strong>受托方:</strong> {{ info.baseCompany?.companyName }}</div>
                <div class="row"><strong>受托方联系人:</strong> {{ info.trusteeContacts?.name }}</div>
                <div class="row"><strong>合同分类:</strong> {{ getContractColor(info.contractType, 'name') }}</div>

                <div class="row"><strong>合同类型:</strong> {{ info.projectType }}</div>
                <div class="row" v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(info.projectType)"><strong>样品处理方式:</strong> {{ returnName(info.sampleManagement) }}</div>
                <div class="row"><strong>核酸抽提:</strong> {{ info.generateContractInfo?.extractionFlag ? '是' : '否' }}
                </div>
                <div class="row"><strong>创建时间:</strong> {{ info.createTime }}</div>

                <div class="row"><strong>签订地点:</strong> {{ info.signingPlace }}</div>
                <div class="row" v-if="info.contractFilePath"><strong>合同:</strong>
                    <van-button size="small" type="primary" @click="download(info.id)">下载</van-button>
                    <van-button size="small" type="primary" @click="preview(info.id)">预览</van-button>
                </div>
                <div class="row"><strong>备注:</strong> {{ info.remark }}</div>

            </van-collapse-item>
        </van-collapse>
        <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
    </div>
</template>

<script>
import { attachmentContract } from "@/api/dilivery/sales/contract";
import FilePreview from "@/components/file/FilePreview.vue";
import ProjectInfoDialog from "@/components/sales/ProjectInfoDialog.vue";
import { getContractColor } from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getProportion } from "@/utils/float_decimal";
const baseURL = process.env.VUE_APP_BASE_API
export default {
    name: "ShowSignInfo",
    props: {
    }, 
    components: { ProjectInfoDialog, FilePreview },
    props: {
    },
    data() {
        return {
            activeNames: '',
            showFile: false,
            fileInfo: '',
        };
    },
    mounted() {
    },
    computed: {
        contract() {
            return JSON.parse(getDataInLocalStorage('mSignData'));
        }
    },
    methods: {
        onClickLeft() {
            this.$router.back();
        },
        returnName(name) {
            switch (name) {
                case 'RETURN_SAMPLE':
                    return '返样'
                case 'SAMPLE_HOLD':
                    return '暂存样品'
                default:
                    return 'NA'
            }
        },
        getProportion,
        getContractColor,
        async download(id) {
            try {
                let url = `${baseURL}/sequencing-contract/attachment/${id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        async preview(id, type) {
            try {
                this.fileInfo = await attachmentContract(id, 'CONTRACT_ANNEX')
                this.showFile = true
            } catch (error) {
                console.log(error);
            }
        },
        close() {
            this.showFile = false
        },
    }
};
</script>

<style scoped>
.initiate-wrap {
    position: fixed;
    inset: 0;
    background: #f7f8fa;
    display: flex;
    flex-direction: column;
    height: 100vh;
}
.van-collapse {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
}
.van-collapse-item {
    margin-bottom: 8px;
}

.row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #fff;
    border-bottom: 1px solid #ebedf0;
}
.row strong {
    color: #323233;
    min-width: 100px;
}
.van-button {
    margin-left: 8px;
}

</style>